<template>
  <div class="home">
    <b-card header="Get your matched set's customised report">
      <div>
        <h3>
          Enter two injectors from your set to get your Excess EXACT MATCH
          report:
        </h3>
        <div class="centred_panel">
          <div>
            <b-form v-on:submit.prevent="double_injector_match_search()">
              <b-form-input
                trim
                v-model="injector_id_one"
                placeholder="Enter first injector ID"
              >
              </b-form-input>
              <b-form-input
                trim
                v-model="injector_id_two"
                placeholder="Enter second injector ID"
              >
              </b-form-input>
              <b-button type="submit" variant="primary">
                <font-awesome-icon icon="search" /> Search
              </b-button>
            </b-form>
            <p v-if="double_injector_search_status">
              {{ double_injector_search_status }}
            </p>

            <p>
              To download your cusomised injector data,
              simply enter the serial number of 2 injectors from your set.
            </p>
          </div>
        </div>
      </div>
    </b-card>
    <b-card v-if="user" header="Manually create cluster">
      <p>
        Enter the injector IDs here to manually create a cluster. The injectors
        must all be of the same injector type, and none of the injectors must be
        currently grouped.
      </p>
      <p>
        Enter injector IDs with no spaces and a comma between them, like this:
      </p>
      <p>ABC123,XYZ456</p>
      <b-textarea v-model="custom_group_injector_ids"></b-textarea>
      <b-button @click="manually_cluster()" variant="primary">
        <font-awesome-icon icon="layer-group" /> Create Cluster
      </b-button>
      <b-alert :variant="manual_cluster_variant" :show="manual_cluster_show">{{
        manual_cluster_text
      }}</b-alert>
    </b-card>

    <b-card v-if="user" header="Account Creation">
      <p>Please contact the administrator to create new user accounts.</p>
      <p>Account creation is managed by the system administrator.</p>
    </b-card>
    <b-card v-if="last_seen_uploader && user" header="System Information">
      <p v-if="last_seen_uploader">
        Uploader script ping time: {{ last_seen_uploader }}
      </p>
      <p>
        The uploader script updates every five minutes. This field will
        automatically update every minute. It was last checked
        {{ uploader_last_checked }}
      </p>
    </b-card>
    <b-card v-if="user" header="View Raw Deadtime Data">
      <p>
        You can view the raw data for a deadtime result. Enter the Injector ID
        that was tested against.
      </p>
      <b-input-group>
        <b-input
          v-model="deadtime_request_injector_id"
          placeholder="Injector ID"
        ></b-input>
        <b-input-group-append>
          <b-button @click="get_deadtime_summary()">Get Results</b-button>
        </b-input-group-append>
      </b-input-group>

      <b-table
        v-if="deadtime_data"
        striped
        hover
        :items="deadtime_data"
        :fields="deadtime_fields"
      >
        <template v-slot:cell(deadtime_id)="data">{{
          data.item.deadtime_id.S
        }}</template>
        <template v-slot:cell(job_id)="data">{{ data.item.job_id.S }}</template>

        <template v-slot:cell(test_timestamp)="data">{{
          data.item.test_timestamp.N | momentFromUnix
        }}</template>
        <template v-slot:cell(raw_filename)="data">
          <b-button
            @click="download_raw_file(data.item.raw_filename.S)"
            variant="danger"
          >
            <h4>Download Raw</h4>
          </b-button>
          <br />
          {{ data.item.raw_filename.S }}
        </template>
        <template v-slot:cell(analysis_filename)="data">
          <b-button
            @click="
              download_raw_file('analysis/' + data.item.analysis_filename.S)
            "
            variant="success"
          >
            <h4>Download Analysis</h4>
          </b-button>
          <br />
          {{ data.item.analysis_filename.S }}
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
// @ is an alias to /src
import LoginForm from "@/components/LoginForm.vue";
import Nav from "@/components/Nav.vue";
import {Auth} from '@aws-amplify/auth'
import datastore from "@/store/store";
import { get, download_file, post } from "@/utilities/requests.js";
import { formatDateSmart } from "@/utilities/dateFormatter.js";

var pako = require("pako");

export default {
  name: "home",
  components: {
    Nav,
    LoginForm,
  },

  filters: {
    // Using global filters registered in main.js
  },
  computed: {
    count() {
      return datastore.state.count;
    },
    logged_in: {
      get() {
        return datastore.state.logged_in;
      },
      // set(newValue) {
      //   datastore.state.logged_in = newValue;
      // },
    },
    user() {
      return datastore.state.user;
    },
  },
  beforeDestroy() {
    // Stop updating uploader ping check
    clearInterval(this.polling);
  },
  data() {
    return {
      message: "start",
      request_error: false,
      request_error_message: "",
      datastore,
      todos: [],
      login_error: "",
      loggedin: false,
      login_checked: false, // If false, we haven't checked login data yet

      signUpConfig: {
        hiddenDefaults: ["phone_number"],
        signUpFields: [
          {
            label: "Username",
            key: "username",
            required: false,
            displayOrder: 30,
          },
          {
            label: "Email",
            key: "email",
            required: true,
            type: "email",
            displayOrder: 10,
          },
          {
            label: "Password",
            key: "password",
            required: true,
            type: "password",
            displayOrder: 20,
          },
        ],
      },

      // System information
      last_seen_uploader: "Loading...",
      polling: null,
      uploader_last_checked: null,

      // Deadtime request
      deadtime_request_injector_id: "a1",
      deadtime_data: null,
      deadtime_fields: [
        "deadtime_id",
        "job_id",
        "raw_filename",
        "test_timestamp",
        "analysis_filename",
      ],
      // Manual clusters
      custom_group_injector_ids: "ABC123,XYZ456",
      manual_cluster_variant: "success",
      manual_cluster_text: "No pending job",
      manual_cluster_show: true,

      // Injectors for the double injector search
      injector_id_one: null,
      injector_id_two: null,
      double_injector_search_status: null,
    };
  },

  methods: {
    async runtest() {
      this.message = "clear";
      // get(`/test`, this.test_success, this);
      await get(`/test`, this.test_success, this);
    },
    test_success(response) {
      this.message = response["data"]["message"];
    },
    handleLogout: function () {
      Auth.signOut().then((res) => (this.loggedin = false));
    },
    handleLogin: function (data) {
      this.loggedin = true;
    },
    async get_deadtime_summary() {
      if (!this.user) {
        return;
      }
      let response = await get(
        `/deadtime/${this.deadtime_request_injector_id}`
      );
      this.deadtime_data = response["data"]["Items"];
      for (let i = 0; i < this.deadtime_data.length; i++) {
        this.deadtime_data[i]["metadata"] = JSON.parse(
          this.deadtime_data[i]["metadata"].S
        );
      }
    },
    async download_raw_file(filename) {
      let response = await post(`/file/admin`, { filename: filename });
      let download_response = download_file(
        response.data["presigned_url"],
        response.data["filename"]
      );
    },
    async get_uploader_ping() {
      if (!this.user) {
        return;
      }
      let response = await get("/system/uploader-ping");
      this.last_seen_uploader =
        response["data"]["Items"][0]["system_value"]["S"];
      this.uploader_last_checked = formatDateSmart(new Date());
    },
    manually_cluster() {
      this.manual_cluster_variant = "warning";
      this.manual_cluster_text = "Clustering, please wait";
      this.manual_cluster_show = true;
      let response = post(`/system/manual-cluster`, {
        injector_ids: this.custom_group_injector_ids,
      })
        .then((response) => {
          this.manual_cluster_variant = "success";
          this.manual_cluster_text = response["data"]["message"];
          this.manual_cluster_show = true;
        })
        .catch((error) => {
          this.manual_cluster_variant = "danger";
          this.manual_cluster_text = error["message"];
          this.manual_cluster_show = true;
        });
    },
    double_injector_match_search() {
      this.double_injector_search_status = "Searching...";
      let response = post(`/group/double_injector_search`, {
        injector_id_one: this.injector_id_one,
        injector_id_two: this.injector_id_two,
      })
        .then((response) => {
          if (response["data"]["success"]) {
            console.log("Success!");
            let url = `/group/summary/${response["data"]["group"]}`;
            this.double_injector_search_status = `Success, redirecting you to ${url}`;
            this.$router.push({
              name: "group_summary",
              params: { group_name: response["data"]["group"] },
            });
          } else {
            console.log(response["data"]["reason"]);
            this.double_injector_search_status = response["data"]["reason"];
          }
        })
        .catch((error) => {
          this.double_injector_search_status =
            "We couldn't get that to work. Please refresh the page and try again, and get in contact with us if it still doesn't work.";
        });
    },
  },
  mounted: async function () {
    try {
      let authUser = await Auth.currentAuthenticatedUser();
      if (authUser) {
        this.loggedin = true;
      }
      // Auth.currentAuthenticatedUser().then(user => (this.loggedin = true));
    } catch (err) {
      // TODO - Check if this will actually throw when unauthenticated
    }
    this.login_checked = true;
    this.get_deadtime_summary();
    this.get_uploader_ping();
    this.polling = setInterval(() => {
      this.get_uploader_ping();
    }, 60000);
  },
};
</script>


<style scoped>
.auth_wrapper {
  color: black;
}
</style>
